export default __webpack_public_path__ + "media/images/start-c9e591fef1e88b891c5de071323d57b8.png";